import { render, staticRenderFns } from "./task-project-create.vue?vue&type=template&id=0c182962&"
import script from "./task-project-create.vue?vue&type=script&lang=js&"
export * from "./task-project-create.vue?vue&type=script&lang=js&"
import style0 from "./task-project-create.vue?vue&type=style&index=0&id=0c182962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports